const $f8e847403f6cae58$export$17d7fd322af6b968 = {
    UP: 0,
    DOWN: 1,
    LEFT: 2,
    RIGHT: 3,
    A: 4,
    B: 5,
    START: 6,
    L: 7,
    R: 8,
    SIZE: 9
};
const $f8e847403f6cae58$var$KeyboardBinding = {
    ArrowUp: $f8e847403f6cae58$export$17d7fd322af6b968.UP,
    ArrowDown: $f8e847403f6cae58$export$17d7fd322af6b968.DOWN,
    ArrowLeft: $f8e847403f6cae58$export$17d7fd322af6b968.LEFT,
    ArrowRight: $f8e847403f6cae58$export$17d7fd322af6b968.RIGHT,
    KeyZ: $f8e847403f6cae58$export$17d7fd322af6b968.A,
    KeyX: $f8e847403f6cae58$export$17d7fd322af6b968.B,
    Enter: $f8e847403f6cae58$export$17d7fd322af6b968.START,
    KeyA: $f8e847403f6cae58$export$17d7fd322af6b968.L,
    KeyS: $f8e847403f6cae58$export$17d7fd322af6b968.R,
    // extra bindings
    KeyW: $f8e847403f6cae58$export$17d7fd322af6b968.UP,
    KeyS: $f8e847403f6cae58$export$17d7fd322af6b968.DOWN,
    KeyA: $f8e847403f6cae58$export$17d7fd322af6b968.LEFT,
    KeyD: $f8e847403f6cae58$export$17d7fd322af6b968.RIGHT,
    KeyJ: $f8e847403f6cae58$export$17d7fd322af6b968.A,
    KeyK: $f8e847403f6cae58$export$17d7fd322af6b968.B,
    Space: $f8e847403f6cae58$export$17d7fd322af6b968.A,
    ShiftLeft: $f8e847403f6cae58$export$17d7fd322af6b968.B,
    KeyQ: $f8e847403f6cae58$export$17d7fd322af6b968.L,
    KeyE: $f8e847403f6cae58$export$17d7fd322af6b968.R
};
class $f8e847403f6cae58$export$2da2653229140a6c {
    #pressed = [];
    #repeated = [];
    #held = [];
    #released = [];
    constructor(){
        document.addEventListener("keydown", (e)=>{
            const input = $f8e847403f6cae58$var$KeyboardBinding[e.code];
            if (input != undefined) {
                this.simulateRepeat(input);
                this.simulatePress(input);
            }
        });
        document.addEventListener("keyup", (e)=>{
            const input = $f8e847403f6cae58$var$KeyboardBinding[e.code];
            if (input != undefined) this.simulateRelease(input);
        });
    }
    simulatePress(input) {
        if (!this.#held[input]) {
            this.#pressed[input] = true;
            this.#held[input] = true;
        }
    }
    simulateRepeat(input) {
        // todo, handle using counters
        if (this.#held[input]) this.#repeated[input] = true;
    }
    simulateRelease(input) {
        if (input != undefined && this.#held[input]) {
            this.#released[input] = true;
            this.#held[input] = false;
        }
    }
    justPressed(input) {
        return this.#pressed[input] == true;
    }
    justRepeated(input) {
        return this.#repeated[input] == true;
    }
    justReleased(input) {
        return this.#released[input] == true;
    }
    isDown(input) {
        return this.#held[input] == true;
    }
    flush() {
        this.#pressed = [];
        this.#released = [];
        this.#repeated = [];
    }
}


const $00387b554b88a86f$export$4a4fccf86f542a62 = 240;
const $00387b554b88a86f$export$a94a52152a1b6dd0 = 160;
const $00387b554b88a86f$export$14a5666d9e2a0a92 = 20;
const $00387b554b88a86f$export$9188d4e069e95fa0 = 5;
const $00387b554b88a86f$export$d1ce89bfcf9b1ff3 = Math.floor($00387b554b88a86f$export$9188d4e069e95fa0 / 2);
const $00387b554b88a86f$export$ad58330ac2844faf = $00387b554b88a86f$export$9188d4e069e95fa0 * $00387b554b88a86f$export$14a5666d9e2a0a92;
const $00387b554b88a86f$export$1ac198198c587660 = $00387b554b88a86f$export$14a5666d9e2a0a92 * 2;
const $00387b554b88a86f$export$80b31447333fcc43 = $00387b554b88a86f$export$14a5666d9e2a0a92 * 1.5;
const $00387b554b88a86f$export$1a6871eb86e4bce9 = 3 * $00387b554b88a86f$export$9188d4e069e95fa0 + 4;
const $00387b554b88a86f$export$da80b4498b9f0c5a = $00387b554b88a86f$export$1a6871eb86e4bce9 + 2;
const $00387b554b88a86f$export$9556950d702f9ce3 = $00387b554b88a86f$export$1ac198198c587660 + $00387b554b88a86f$export$ad58330ac2844faf + $00387b554b88a86f$export$14a5666d9e2a0a92;
const $00387b554b88a86f$export$f8f3cccce646cdfb = $00387b554b88a86f$export$80b31447333fcc43 - Math.floor($00387b554b88a86f$export$da80b4498b9f0c5a / 2);
const $00387b554b88a86f$export$56d196d2844d1ca1 = {
    // shared
    BOARD: "#001948ff",
    BORDER: "#889EB3",
    // grid
    GRID_BACKGROUND: "#124D7F",
    GRID_CURSOR: "lime",
    GRID_CURSOR_LETTER: "#0006",
    LINE_SHADOW: "#00000033",
    // line
    PROCESSING_LETTER: "WHITE",
    CORRECT_LETTER: "lime",
    INCORRECT_LETTER: "red",
    INVALID_LETTER: "orange",
    // inventory
    INVENTORY_CURSOR_LIGHT: "#64ff49ff",
    INVENTORY_CURSOR_MID: "#11b41cff",
    INVENTORY_CURSOR_DARK: "#04843eff"
};


const $30e9a94c591cfedc$var$GRID_BORDER_SIZE = 6;
class $30e9a94c591cfedc$export$2e2bcd8739ae039 {
    #hasFocus = false;
    #focusedTime = 0;
    #selectedShape = null;
    #shapes = [];
    cursorPos = {
        x: 2,
        y: 2
    };
    onExit = ()=>{};
    onReturnShape = (shape)=>{};
    setShapes(shapes) {
        this.#shapes = shapes;
    }
    selectShape(shape) {
        this.#selectedShape = shape;
    }
    #hasSameColorNeighbor(shape, x, y) {
        const hasSameColor = (x, y)=>{
            const s = this.getShape(x, y);
            return s && s != shape && s.color == shape.color;
        };
        return hasSameColor(x - 1, y) || hasSameColor(x + 1, y) || hasSameColor(x, y - 1) || hasSameColor(x, y + 1);
    }
    isValid() {
        for(let y = 0; y < (0, $00387b554b88a86f$export$9188d4e069e95fa0); y++)for(let x = 0; x < (0, $00387b554b88a86f$export$9188d4e069e95fa0); x++){
            const shape = this.getShape(x, y);
            if (!shape) continue;
            if (this.#hasSameColorNeighbor(shape, x, y)) return false;
        }
        return true;
    }
    #grabShape() {
        const shape = this.getShape(this.cursorPos.x, this.cursorPos.y);
        if (!shape) return null;
        const index = this.#shapes.indexOf(shape);
        this.#shapes.splice(index, 1);
        this.#selectedShape = shape;
        this.cursorPos.x = shape.x;
        this.cursorPos.y = shape.y;
        return shape;
    }
    #keepSelectedShapeInBounds() {
        if (!this.#selectedShape) return;
        let moved = false;
        do {
            for(let x = 0; x < (0, $00387b554b88a86f$export$9188d4e069e95fa0); x++){
                if (this.#selectedShape.existsAt(x, -1)) this.#selectedShape.y += 1;
                if (this.#selectedShape.existsAt(x, (0, $00387b554b88a86f$export$9188d4e069e95fa0))) this.#selectedShape.y -= 1;
            }
            for(let y = 0; y < (0, $00387b554b88a86f$export$9188d4e069e95fa0); y++){
                if (this.#selectedShape.existsAt(-1, y)) this.#selectedShape.x += 1;
                if (this.#selectedShape.existsAt((0, $00387b554b88a86f$export$9188d4e069e95fa0), y)) this.#selectedShape.x -= 1;
            }
        }while (moved);
        this.cursorPos.x = this.#selectedShape.x;
        this.cursorPos.y = this.#selectedShape.y;
    }
    #placeSelectedShape() {
        if (!this.#selectedShape) return false;
        for(let x = 0; x < (0, $00387b554b88a86f$export$9188d4e069e95fa0); x++)for(let y = 0; y < (0, $00387b554b88a86f$export$9188d4e069e95fa0); y++){
            if (!this.#selectedShape.existsAt(x, y)) continue;
            const shape = this.getShape(x, y);
            if (shape) // todo: play sfx on fail?
            return false;
        }
        this.#shapes.push(this.#selectedShape);
        this.#selectedShape = null;
        return true;
    }
    getShape(x, y) {
        return this.#shapes.find((shape)=>shape.existsAt(x, y));
    }
    giveFocus() {
        this.#hasFocus = true;
        this.#focusedTime = 0;
    }
    removeFocus() {
        this.#hasFocus = false;
    }
    update(inputManager, delta) {
        this.#focusedTime += delta;
        const left = inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).LEFT) || inputManager.justRepeated((0, $f8e847403f6cae58$export$17d7fd322af6b968).LEFT);
        const right = inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).RIGHT) || inputManager.justRepeated((0, $f8e847403f6cae58$export$17d7fd322af6b968).RIGHT);
        const up = inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).UP) || inputManager.justRepeated((0, $f8e847403f6cae58$export$17d7fd322af6b968).UP);
        const down = inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).DOWN) || inputManager.justRepeated((0, $f8e847403f6cae58$export$17d7fd322af6b968).DOWN);
        if (left) this.cursorPos.x -= 1;
        if (right) this.cursorPos.x += 1;
        if (up) this.cursorPos.y -= 1;
        if (down) this.cursorPos.y += 1;
        if (!this.#selectedShape && this.cursorPos.x >= (0, $00387b554b88a86f$export$9188d4e069e95fa0)) this.onExit(this.cursorPos);
        this.cursorPos.x = Math.max(0, this.cursorPos.x);
        this.cursorPos.x = Math.min((0, $00387b554b88a86f$export$9188d4e069e95fa0) - 1, this.cursorPos.x);
        this.cursorPos.y = Math.max(0, this.cursorPos.y);
        this.cursorPos.y = Math.min((0, $00387b554b88a86f$export$9188d4e069e95fa0) - 1, this.cursorPos.y);
        if (this.#selectedShape) {
            this.#selectedShape.x = this.cursorPos.x;
            this.#selectedShape.y = this.cursorPos.y;
            if (inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).L)) this.#selectedShape.rotateLeft();
            if (inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).R)) this.#selectedShape.rotate();
            this.#keepSelectedShapeInBounds();
            if (inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).A)) this.#placeSelectedShape();
            else if (inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).B)) {
                const shape = this.#selectedShape;
                this.#selectedShape = null;
                this.#shapes = this.#shapes.filter((s)=>s != shape);
                this.onReturnShape(shape);
            }
        } else {
            if (inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).A)) this.#grabShape();
            else if (inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).B)) this.onExit(this.cursorPos);
            else if (inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).START)) // jump to the last item: start
            this.onExit({
                x: 0,
                y: 99
            });
        }
    }
    render(ctx) {
        // border
        ctx.fillStyle = (0, $00387b554b88a86f$export$56d196d2844d1ca1).BORDER;
        ctx.fillRect((0, $00387b554b88a86f$export$1ac198198c587660) - $30e9a94c591cfedc$var$GRID_BORDER_SIZE, (0, $00387b554b88a86f$export$80b31447333fcc43) - $30e9a94c591cfedc$var$GRID_BORDER_SIZE, (0, $00387b554b88a86f$export$ad58330ac2844faf) + $30e9a94c591cfedc$var$GRID_BORDER_SIZE * 2, (0, $00387b554b88a86f$export$ad58330ac2844faf) + $30e9a94c591cfedc$var$GRID_BORDER_SIZE * 2);
        // background
        ctx.fillStyle = (0, $00387b554b88a86f$export$56d196d2844d1ca1).GRID_BACKGROUND;
        ctx.fillRect((0, $00387b554b88a86f$export$1ac198198c587660), (0, $00387b554b88a86f$export$80b31447333fcc43), (0, $00387b554b88a86f$export$ad58330ac2844faf), (0, $00387b554b88a86f$export$ad58330ac2844faf));
        // blocks
        for(let x = 0; x < (0, $00387b554b88a86f$export$9188d4e069e95fa0); x++)for(let y = 0; y < (0, $00387b554b88a86f$export$9188d4e069e95fa0); y++){
            const shape = this.getShape(x, y);
            if (shape) {
                ctx.fillStyle = shape.color;
                ctx.fillRect((0, $00387b554b88a86f$export$1ac198198c587660) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * x, (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * y, (0, $00387b554b88a86f$export$14a5666d9e2a0a92), (0, $00387b554b88a86f$export$14a5666d9e2a0a92));
            }
            if (this.#selectedShape && this.#selectedShape.existsAt(x, y)) {
                ctx.globalAlpha = 0.75;
                ctx.fillStyle = this.#selectedShape.color;
                ctx.fillRect((0, $00387b554b88a86f$export$1ac198198c587660) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * x, (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * y, (0, $00387b554b88a86f$export$14a5666d9e2a0a92), (0, $00387b554b88a86f$export$14a5666d9e2a0a92));
                ctx.globalAlpha = 1;
            }
        }
        ctx.fillStyle = (0, $00387b554b88a86f$export$56d196d2844d1ca1).LINE_SHADOW;
        ctx.beginPath();
        // to the right
        ctx.moveTo((0, $00387b554b88a86f$export$1ac198198c587660), (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * 2);
        ctx.lineTo((0, $00387b554b88a86f$export$1ac198198c587660) + (0, $00387b554b88a86f$export$ad58330ac2844faf), (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * 2);
        // center
        ctx.lineTo((0, $00387b554b88a86f$export$1ac198198c587660) + (0, $00387b554b88a86f$export$ad58330ac2844faf), (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * 2.5);
        // back to the left
        ctx.lineTo((0, $00387b554b88a86f$export$1ac198198c587660) + (0, $00387b554b88a86f$export$ad58330ac2844faf), (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * 3);
        ctx.lineTo((0, $00387b554b88a86f$export$1ac198198c587660), (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * 3);
        // auto closes
        ctx.fill();
        // draw cursor
        if (this.#hasFocus) {
            const { x: x, y: y } = this.cursorPos;
            ctx.strokeStyle = (0, $00387b554b88a86f$export$56d196d2844d1ca1).GRID_CURSOR;
            ctx.strokeRect((0, $00387b554b88a86f$export$1ac198198c587660) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * x + 0.5, (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * y + 0.5, (0, $00387b554b88a86f$export$14a5666d9e2a0a92) - 1, (0, $00387b554b88a86f$export$14a5666d9e2a0a92) - 1);
            // draw shape letter
            const shape = this.getShape(x, y);
            if (!this.#selectedShape && shape) {
                ctx.fillStyle = (0, $00387b554b88a86f$export$56d196d2844d1ca1).GRID_CURSOR_LETTER;
                ctx.font = "16px bn6-bold";
                ctx.textBaseline = "top";
                ctx.fillText(shape.letter, (0, $00387b554b88a86f$export$1ac198198c587660) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * x + 6, (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * y + 3);
            }
        }
    }
}




// [0, n)
function $2ce087bca3075e18$export$3c5f89dae98e900b(n) {
    return Math.floor(Math.random() * n);
}
function $2ce087bca3075e18$export$114aa43ee4755930(array) {
    return array[$2ce087bca3075e18$export$3c5f89dae98e900b(array.length)];
}


class $376aef2b802d0445$export$2e2bcd8739ae039 {
    #hasFocus = false;
    #focusTime = 0;
    #shapes = [];
    cursorIndex = 0;
    onRun = ()=>{};
    onExit = (gridPos)=>{};
    onSelection = (shape)=>{};
    giveFocus() {
        this.#hasFocus = true;
        this.#focusTime = 0;
    }
    removeFocus() {
        this.#hasFocus = false;
        this.#focusTime = 0;
    }
    setShapes(shapes) {
        shapes.forEach((shape)=>{
            shape.x = Math.floor((0, $00387b554b88a86f$export$9188d4e069e95fa0) / 2);
            shape.y = Math.floor((0, $00387b554b88a86f$export$9188d4e069e95fa0) / 2);
            shape.rotation = (0, $2ce087bca3075e18$export$3c5f89dae98e900b)(4);
        });
        this.#shapes = shapes;
    }
    addShape(shape) {
        shape.x = Math.floor((0, $00387b554b88a86f$export$9188d4e069e95fa0) / 2);
        shape.y = Math.floor((0, $00387b554b88a86f$export$9188d4e069e95fa0) / 2);
        this.#shapes.push(shape);
    }
    update(inputManager, delta) {
        this.#focusTime += delta;
        if (inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).LEFT)) {
            this.onExit(this.cursorIndex);
            return;
        }
        const pressedUp = inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).UP) || inputManager.justRepeated((0, $f8e847403f6cae58$export$17d7fd322af6b968).UP);
        const pressedDown = inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).DOWN) || inputManager.justRepeated((0, $f8e847403f6cae58$export$17d7fd322af6b968).DOWN);
        if (pressedUp) this.cursorIndex -= 1;
        if (pressedDown) this.cursorIndex += 1;
        if (inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).START)) this.cursorIndex = this.#shapes.length;
        this.cursorIndex = Math.max(0, this.cursorIndex);
        this.cursorIndex = Math.min(this.#shapes.length, this.cursorIndex);
        if (inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).A)) {
            if (this.cursorIndex < this.#shapes.length) {
                const [removedShape] = this.#shapes.splice(this.cursorIndex, 1);
                this.onSelection(removedShape);
            } else this.onRun();
        }
    }
    render(ctx) {
        ctx.font = "16px bn6-bold";
        ctx.textBaseline = "top";
        const width = 38;
        const height = (0, $00387b554b88a86f$export$1a6871eb86e4bce9);
        for(let i = 0; i < this.#shapes.length; i++){
            const shape = this.#shapes[i];
            const startX = (0, $00387b554b88a86f$export$9556950d702f9ce3);
            const startY = (0, $00387b554b88a86f$export$f8f3cccce646cdfb) + (0, $00387b554b88a86f$export$da80b4498b9f0c5a) * i;
            // render border
            ctx.fillStyle = (0, $00387b554b88a86f$export$56d196d2844d1ca1).BORDER;
            ctx.fillRect(startX, startY, width, height);
            // render bg
            ctx.fillStyle = (0, $00387b554b88a86f$export$56d196d2844d1ca1).GRID_BACKGROUND;
            ctx.fillRect(startX + 2, startY + 2, width - 4, height - 4);
            // render mini shape
            ctx.fillStyle = shape.color;
            for(let x = 0; x < 5; x++)for(let y = 0; y < 5; y++){
                if (!shape.existsAt(x, y)) continue;
                ctx.fillRect(startX + x * 3 + 18, startY + y * 3 + 2, 3, 3);
            }
            ctx.fillStyle = "white";
            ctx.fillText(shape.letter, startX + 6, startY + 2);
        }
        // render run button
        {
            const startX = (0, $00387b554b88a86f$export$9556950d702f9ce3);
            const startY = (0, $00387b554b88a86f$export$f8f3cccce646cdfb) + (0, $00387b554b88a86f$export$da80b4498b9f0c5a) * this.#shapes.length;
            // render border
            ctx.fillStyle = (0, $00387b554b88a86f$export$56d196d2844d1ca1).BORDER;
            ctx.fillRect(startX, startY, width, height);
            // render bg
            ctx.fillStyle = "lime";
            ctx.fillRect(startX + 2, startY + 2, width - 4, height - 4);
            ctx.fillStyle = "white";
            ctx.fillText("RUN", startX + 6, startY + 3);
        }
        if (this.#hasFocus) {
            const startX = Math.floor((0, $00387b554b88a86f$export$9556950d702f9ce3) - 9 + Math.sin(this.#focusTime * 16) * 1.5);
            const startY = (0, $00387b554b88a86f$export$f8f3cccce646cdfb) + (0, $00387b554b88a86f$export$da80b4498b9f0c5a) * this.cursorIndex;
            ctx.strokeStyle = (0, $00387b554b88a86f$export$56d196d2844d1ca1).INVENTORY_CURSOR_LIGHT;
            ctx.fillStyle = (0, $00387b554b88a86f$export$56d196d2844d1ca1).INVENTORY_CURSOR_MID;
            ctx.beginPath();
            ctx.moveTo(startX + 0.5, startY + 2);
            ctx.lineTo(startX + 8.5, startY + height / 2);
            ctx.lineTo(startX + 0.5, startY + height - 2);
            ctx.stroke();
            ctx.closePath();
            ctx.fill();
        }
    }
}




class $47117747e6c50692$export$2e2bcd8739ae039 {
    #progress = 0;
    #grid;
    #word;
    #builtWord;
    #validGrid;
    constructor(grid, word){
        this.#grid = grid;
    }
    onSuccess = ()=>{};
    onExit = ()=>{};
    setWord(word) {
        this.#word = word;
    }
    giveFocus() {
        this.#progress = 0;
        this.#builtWord = null;
    }
    removeFocus() {
        this.#progress = 0;
    }
    #reviewGrid() {
        this.#builtWord = "";
        for(let i = 0; i < (0, $00387b554b88a86f$export$9188d4e069e95fa0); i++){
            const shape = this.#grid.getShape(i, (0, $00387b554b88a86f$export$d1ce89bfcf9b1ff3));
            this.#builtWord += shape ? shape.letter : "?";
        }
        this.#validGrid = this.#grid.isValid();
    }
    update(inputManager, delta) {
        this.#progress = Math.min(1, this.#progress + delta / 2);
        const accept = inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).A);
        const cancel = inputManager.justPressed((0, $f8e847403f6cae58$export$17d7fd322af6b968).B);
        if ((accept || cancel) && this.#progress == 1) this.onExit();
        if (!this.#builtWord && this.#progress == 1) this.#reviewGrid();
    }
    #renderLine(ctx) {
        ctx.beginPath();
        const progressWidth = (0, $00387b554b88a86f$export$ad58330ac2844faf) * this.#progress;
        // to the right
        ctx.moveTo((0, $00387b554b88a86f$export$1ac198198c587660), (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * 2);
        ctx.lineTo((0, $00387b554b88a86f$export$1ac198198c587660) + progressWidth, (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * 2);
        // center
        ctx.lineTo((0, $00387b554b88a86f$export$1ac198198c587660) + progressWidth, (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * 2.5);
        // back to the left
        ctx.lineTo((0, $00387b554b88a86f$export$1ac198198c587660) + progressWidth, (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * 3);
        ctx.lineTo((0, $00387b554b88a86f$export$1ac198198c587660), (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * 3);
        ctx.fill();
    }
    #renderText(ctx, offsetX, offsetY) {
        for(let i = 0; i < (0, $00387b554b88a86f$export$9188d4e069e95fa0) * this.#progress - 0.5; i++){
            const shape = this.#grid.getShape(i, (0, $00387b554b88a86f$export$d1ce89bfcf9b1ff3));
            ctx.font = "16px bn6-bold";
            ctx.fillText(shape ? shape.letter : "?", (0, $00387b554b88a86f$export$1ac198198c587660) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * i + 6 + offsetX, (0, $00387b554b88a86f$export$80b31447333fcc43) + (0, $00387b554b88a86f$export$14a5666d9e2a0a92) * (0, $00387b554b88a86f$export$d1ce89bfcf9b1ff3) + 3 + offsetY);
        }
    }
    render(ctx) {
        ctx.fillStyle = "#ffff0066";
        this.#renderLine(ctx);
        let text_color;
        if (this.#progress < 1) text_color = (0, $00387b554b88a86f$export$56d196d2844d1ca1).PROCESSING_LETTER;
        else if (this.#builtWord == this.#word) text_color = this.#validGrid ? (0, $00387b554b88a86f$export$56d196d2844d1ca1).CORRECT_LETTER : (0, $00387b554b88a86f$export$56d196d2844d1ca1).INVALID_LETTER;
        else text_color = (0, $00387b554b88a86f$export$56d196d2844d1ca1).INCORRECT_LETTER;
        // text shadow
        ctx.fillStyle = text_color;
        ctx.globalAlpha = 0.5;
        this.#renderText(ctx, 1, 1);
        // darken shadow
        ctx.fillStyle = "black";
        ctx.globalAlpha = 0.5;
        this.#renderText(ctx, 1, 1);
        // draw text
        ctx.globalAlpha = 1;
        ctx.fillStyle = text_color;
        this.#renderText(ctx, 0, 0);
    }
}




const $35d204e98b857052$var$BUTTON_SIZE = 24;
class $35d204e98b857052$export$2e2bcd8739ae039 {
    #buttons = [
        {
            binding: (0, $f8e847403f6cae58$export$17d7fd322af6b968).L,
            x: 0,
            y: 1,
            w: 2,
            h: 1
        },
        {
            binding: (0, $f8e847403f6cae58$export$17d7fd322af6b968).R,
            x: (0, $00387b554b88a86f$export$4a4fccf86f542a62) / $35d204e98b857052$var$BUTTON_SIZE - 2,
            y: 1,
            w: 2,
            h: 1
        },
        {
            binding: (0, $f8e847403f6cae58$export$17d7fd322af6b968).LEFT,
            x: 1,
            y: 4,
            w: 1,
            h: 1
        },
        {
            binding: (0, $f8e847403f6cae58$export$17d7fd322af6b968).RIGHT,
            x: 3,
            y: 4,
            w: 1,
            h: 1
        },
        {
            binding: (0, $f8e847403f6cae58$export$17d7fd322af6b968).UP,
            x: 2,
            y: 3,
            w: 1,
            h: 1
        },
        {
            binding: (0, $f8e847403f6cae58$export$17d7fd322af6b968).DOWN,
            x: 2,
            y: 5,
            w: 1,
            h: 1
        },
        {
            binding: (0, $f8e847403f6cae58$export$17d7fd322af6b968).A,
            x: (0, $00387b554b88a86f$export$4a4fccf86f542a62) / $35d204e98b857052$var$BUTTON_SIZE - 3,
            y: 3,
            w: 1,
            h: 1
        },
        {
            binding: (0, $f8e847403f6cae58$export$17d7fd322af6b968).B,
            x: (0, $00387b554b88a86f$export$4a4fccf86f542a62) / $35d204e98b857052$var$BUTTON_SIZE - 4,
            y: 4,
            w: 1,
            h: 1
        }
    ];
    #canvas;
    #state = [];
    #inputManager;
    constructor(canvas, inputManager){
        this.#canvas = canvas;
        this.#inputManager = inputManager;
        canvas.addEventListener("touchstart", (e)=>{
            this.#updateFromTouchEvent(e);
        });
        canvas.addEventListener("touchmove", (e)=>{
            this.#updateFromTouchEvent(e);
        });
        canvas.addEventListener("touchend", (e)=>{
            this.#updateFromTouchEvent(e);
        });
    }
    #updateFromTouchEvent(event) {
        const canvas = this.#canvas;
        const canvasRect = canvas.getBoundingClientRect();
        const newState = [];
        for (const touch of event.targetTouches){
            // get corrected canvas position
            let x = (touch.clientX - canvasRect.x) / canvasRect.width * canvas.width;
            let y = (touch.clientY - canvasRect.y) / canvasRect.height * canvas.height;
            // transform position to button space
            x = x / $35d204e98b857052$var$BUTTON_SIZE;
            y = (y - (0, $00387b554b88a86f$export$a94a52152a1b6dd0)) / $35d204e98b857052$var$BUTTON_SIZE;
            for (const button of this.#buttons)if (x > button.x && y > button.y && x < button.x + button.w && y < button.y + button.h) newState[button.binding] = true;
        }
        for(let i = 0; i < (0, $f8e847403f6cae58$export$17d7fd322af6b968).SIZE; i++){
            if (this.#state[i] && !newState[i]) this.#inputManager.simulateRelease(i);
            else if (!this.#state[i] && newState[i]) this.#inputManager.simulatePress(i);
        }
        this.#state = newState;
    }
    update() {
        for(let i = 0; i < (0, $f8e847403f6cae58$export$17d7fd322af6b968).SIZE; i++)if (this.#state[i]) this.#inputManager.simulatePress(i);
    }
    render(ctx) {
        ctx.fillStyle = "white";
        for (const button of this.#buttons)ctx.fillRect(button.x * $35d204e98b857052$var$BUTTON_SIZE, (0, $00387b554b88a86f$export$a94a52152a1b6dd0) + button.y * $35d204e98b857052$var$BUTTON_SIZE, button.w * $35d204e98b857052$var$BUTTON_SIZE, button.h * $35d204e98b857052$var$BUTTON_SIZE);
    }
}





const $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN = 5;
const $d12e779adf4758b5$var$CENTER_LEN = Math.floor($d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN / 2);
class $d12e779adf4758b5$export$2e2bcd8739ae039 {
    #blocks = [];
    constructor(){
        this.color = "";
        this.letter = "";
        this.x = 0;
        this.y = 0;
        this.rotation = 0;
        for(let i = 0; i < $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN * $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN; i++)this.#blocks[i] = false;
    }
    isColumn() {
        let count = 0;
        for(let i = 0; i < $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN; i++)for(let j = 0; j < $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN; j++){
            const index = i * $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN + j;
            if (!this.#blocks[index]) continue;
            if (j != $d12e779adf4758b5$var$CENTER_LEN) // found a block outside of a column
            return false;
            count++;
        }
        // 1x1 is not a column
        return count > 1;
    }
    rotate() {
        this.rotation += 1;
        this.rotation %= 4;
    }
    rotateLeft() {
        this.rotation -= 1;
        if (this.rotation < 0) this.rotation = 3;
    }
    canSet(x, y) {
        const index = this.getIndex(x, y);
        return index >= 0 && index < $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN * $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN;
    }
    set(x, y, value) {
        const index = this.getIndex(x, y);
        this.#blocks[index] = value;
    }
    existsAt(x, y) {
        const index = this.getIndex(x, y);
        return this.#blocks[index] == true;
    }
    countBlocks() {
        let count = 0;
        for(let i = 0; i < this.#blocks.length; i++)if (this.#blocks[i]) count++;
        return count;
    }
    recalculateCenter() {
        const bounds = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        };
        const validPositions = [];
        for(let i = 0; i < $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN; i++)for(let j = 0; j < $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN; j++){
            const index = i * $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN + j;
            if (!this.#blocks[index]) continue;
            const x = j - $d12e779adf4758b5$var$CENTER_LEN;
            const y = i - $d12e779adf4758b5$var$CENTER_LEN;
            if (x < bounds.left) bounds.left = x;
            if (y < bounds.top) bounds.top = y;
            if (x > bounds.right) bounds.right = x;
            if (y > bounds.bottom) bounds.bottom = y;
            validPositions.push({
                x: x,
                y: y
            });
        }
        const trueCenter = {
            x: (bounds.left + bounds.right) / 2,
            y: (bounds.bottom + bounds.top) / 2
        };
        validPositions.sort((posA, posB)=>{
            const manhattanDistA = Math.abs(trueCenter.x - posA.x) + Math.abs(trueCenter.y - posA.y);
            const manhattanDistB = Math.abs(trueCenter.x - posB.x) + Math.abs(trueCenter.y - posB.y);
            return manhattanDistA < manhattanDistB ? -1 : 1;
        });
        const newCenter = validPositions[0];
        this.x -= newCenter.x;
        this.y -= newCenter.y;
        const updatedBlocks = [
            ...this.#blocks
        ];
        for(let i = 0; i < $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN; i++)for(let j = 0; j < $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN; j++){
            let value = false;
            const oldX = j + newCenter.x;
            const oldY = i + newCenter.y;
            if (oldX >= 0 && oldY >= 0 && oldX < $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN && oldY < $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN) {
                const index = oldY * $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN + oldX;
                value = this.#blocks[index];
            }
            const index = i * $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN + j;
            updatedBlocks[index] = value;
        }
        this.#blocks = updatedBlocks;
    }
    getIndex(x, y) {
        x = x - this.x;
        y = y - this.y;
        let transformedX, transformedY;
        switch(this.rotation){
            case 0:
                // [x-y-, x+y-]
                // [x-y+, x+y+]
                transformedX = x;
                transformedY = y;
                break;
            case 1:
                // 90 clockwise
                // [x-y+, x-y-]
                // [x+y+, x+y-]
                transformedX = y;
                transformedY = $d12e779adf4758b5$var$CENTER_LEN - x - 2;
                break;
            case 2:
                // 180
                // [x+y+, x-y+]
                // [x+y-, x-y-]
                transformedX = $d12e779adf4758b5$var$CENTER_LEN - x - 2;
                transformedY = $d12e779adf4758b5$var$CENTER_LEN - y - 2;
                break;
            case 3:
                // 270
                // [x+y-, x+y+]
                // [x-y-, x-y+]
                transformedX = $d12e779adf4758b5$var$CENTER_LEN - y - 2;
                transformedY = x;
                break;
        }
        transformedX += $d12e779adf4758b5$var$CENTER_LEN;
        transformedY += $d12e779adf4758b5$var$CENTER_LEN;
        if (transformedX < 0 || transformedY < 0 || transformedX >= $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN || transformedY >= $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN) return -1;
        return transformedY * $d12e779adf4758b5$var$MAX_SHAPE_SIDE_LEN + transformedX;
    }
}



const $2a59e984b87de363$var$GRID_SIDE_LEN = 5;
let $2a59e984b87de363$var$COLORS = [
    "#DE1100",
    "#D688C0",
    "#2880D9",
    "#19C000",
    "#D8DA00",
    "#D8D8D8"
];
const $2a59e984b87de363$var$MAX_SHAPE_SIZE = 4;
const $2a59e984b87de363$var$MAX_COLORS = 4;
function $2a59e984b87de363$var$generateColors() {
    const colors = [];
    while(colors.length < $2a59e984b87de363$var$MAX_COLORS){
        const color = (0, $2ce087bca3075e18$export$114aa43ee4755930)($2a59e984b87de363$var$COLORS);
        if (!colors.includes(color)) colors.push(color);
    }
    return colors;
}
function $2a59e984b87de363$var$internalGenerateWordShapes(word) {
    let shapes = [];
    let nextRun = [];
    let colors = $2a59e984b87de363$var$generateColors();
    let colorOffset = (0, $2ce087bca3075e18$export$3c5f89dae98e900b)(colors.length);
    for(let i = 0; i < $2a59e984b87de363$var$GRID_SIDE_LEN; i++){
        const shape = new (0, $d12e779adf4758b5$export$2e2bcd8739ae039)();
        shape.color = colors[(i + colorOffset) % colors.length];
        shape.x = i;
        shape.y = 2;
        shape.letter = word[i];
        shape.set(shape.x, shape.y, true);
        shapes.push(shape);
        nextRun.push({
            shape: shape,
            x: shape.x,
            y: shape.y - 1
        });
        nextRun.push({
            shape: shape,
            x: shape.x,
            y: shape.y + 1
        });
        if (word[i] == word[i + 1]) {
            // merge repeated letter
            shape.set(shape.x + 1, shape.y, true);
            i++;
            nextRun.push({
                shape: shape,
                x: shape.x + 1,
                y: shape.y - 1
            });
            nextRun.push({
                shape: shape,
                x: shape.x + 1,
                y: shape.y + 1
            });
        }
    }
    const spread = ({ shape: shape, x: x, y: y })=>{
        nextRun.push({
            shape: shape,
            x: x - 1,
            y: y
        });
        nextRun.push({
            shape: shape,
            x: x + 1,
            y: y
        });
        nextRun.push({
            shape: shape,
            x: x,
            y: y - 1
        });
        nextRun.push({
            shape: shape,
            x: x,
            y: y + 1
        });
    };
    function hasSameColorNeighbor(shape, x, y) {
        function hasSameColor(x, y) {
            const s = shapes.find((shape)=>shape.existsAt(x, y));
            return s && s != shape && s.color == shape.color;
        }
        return hasSameColor(x - 1, y) || hasSameColor(x + 1, y) || hasSameColor(x, y - 1) || hasSameColor(x, y + 1);
    }
    while(nextRun.length > 0){
        const run = nextRun;
        nextRun = [];
        for (const { shape: shape, x: x, y: y } of run){
            if (x < 0 || y < 0 || x >= $2a59e984b87de363$var$GRID_SIDE_LEN || y >= $2a59e984b87de363$var$GRID_SIDE_LEN) continue;
            const otherShape = shapes.find((shape)=>shape.existsAt(x, y));
            if (otherShape) continue;
            const growShape = ()=>{
                // spread if we can, or drop this search
                if (hasSameColorNeighbor(shape, x, y)) return;
                if (shape.countBlocks() >= $2a59e984b87de363$var$MAX_SHAPE_SIZE || !shape.canSet(x, y)) return;
                shape.set(x, y, true);
                spread({
                    shape: shape,
                    x: x,
                    y: y
                });
            };
            const tryLater = ()=>{
                // do nothing, but try again next run
                nextRun.push({
                    shape: shape,
                    x: x,
                    y: y
                });
            };
            const options = [
                growShape,
                tryLater
            ];
            (0, $2ce087bca3075e18$export$114aa43ee4755930)(options)();
        }
    }
    return shapes;
}
function $2a59e984b87de363$export$118f84f93f08b80c(word) {
    let shapes;
    do shapes = $2a59e984b87de363$var$internalGenerateWordShapes(word);
    while (shapes.filter((shape)=>shape.isColumn()).length > 1);
    for (const shape of shapes)shape.recalculateCenter();
    return shapes;
}
function $2a59e984b87de363$export$c89aaa4a593054ed(word) {
    let shapes;
    do shapes = $2a59e984b87de363$var$internalGenerateWordShapes(word);
    while (shapes.filter((shape)=>shape.isColumn()).length > 1);
    return shapes;
}


var $09b17a1eda282565$export$2e2bcd8739ae039 = [
    // misc
    "ZENNY",
    "CHIPS",
    "CYBER",
    "PANEL",
    "COLOR",
    "POINT",
    "GAUGE",
    "VIRUS",
    "DRILL",
    "SNEAK",
    "HPMEM",
    "BREAK",
    // NCP
    "SHOES",
    "HUMOR",
    "TANGO",
    "ARMOR",
    "BLOCK",
    // humans
    "CHAUD",
    "BARYL",
    // navis
    "GLIDE",
    "PROTO",
    // "NUMBR", // NumbrMan Chips + NumberMan
    "MAGIC",
    "SKULL",
    "SHARK",
    "PHARO",
    // "SHADO",
    // "MAGNT",
    // "NAPLM",
    "METAL",
    "JAPAN",
    // "BUBBL",
    "SPARK",
    "VIDEO",
    "SHADE",
    "COSMO",
    "MEDDY",
    "CHAOS",
    "SPOUT",
    "BLAST",
    "JUDGE",
    "ERASE",
    "TENGU",
    "BEAST",
    "CACHE",
    "KENDO",
    "LASER",
    "QUICK",
    "STONE",
    // chips
    "STEAL",
    "CLOUD",
    "INVIS",
    "POPUP",
    "SWORD",
    "BLADE",
    "PUNCH",
    "LANCE",
    "GUARD",
    "RECOV",
    "ARROW",
    "SPICE",
    "SHAKE",
    "PANIC",
    "BATCH",
    "SNAKE",
    "QUAKE",
    "DELTA",
    "STAGE",
    // viruses
    "BILLY",
    "FISHY",
    "RATTY",
    "PUFFY",
    "JELLY",
    "BUNNY",
    "POWIE",
    "PENGI",
    "VINEY",
    "ALPHA",
    "TOTEM",
    "TWINS",
    "KILBY",
    "WALLA",
    "BATTY",
    "HANDI",
    "ZOMON",
    "BRUTE",
    "HEADY",
    "GOLEM"
];


function $d8bf78f2b5ef2882$export$2e2bcd8739ae039(array) {
    if (!Array.isArray(array)) throw new TypeError(`Expected an array, got ${typeof array}`);
    array = [
        ...array
    ];
    for(let index = array.length - 1; index > 0; index--){
        const newIndex = Math.floor(Math.random() * (index + 1));
        [array[index], array[newIndex]] = [
            array[newIndex],
            array[index]
        ];
    }
    return array;
}


class $2fdd4cd8dcfa2293$export$2e2bcd8739ae039 {
    #inventory = new (0, $376aef2b802d0445$export$2e2bcd8739ae039)();
    #grid = new (0, $30e9a94c591cfedc$export$2e2bcd8739ae039)();
    #runLine = new (0, $47117747e6c50692$export$2e2bcd8739ae039)(this.#grid);
    #buttons;
    #focusedUI = this.#inventory;
    #inputManager = new (0, $f8e847403f6cae58$export$2da2653229140a6c)();
    constructor(canvas){
        this.#buttons = new (0, $35d204e98b857052$export$2e2bcd8739ae039)(canvas, this.#inputManager);
        const word = (0, $2ce087bca3075e18$export$114aa43ee4755930)((0, $09b17a1eda282565$export$2e2bcd8739ae039));
        this.#runLine.setWord(word);
        this.#inventory.setShapes((0, $d8bf78f2b5ef2882$export$2e2bcd8739ae039)((0, $2a59e984b87de363$export$118f84f93f08b80c)(word)));
        this.focusOn(this.#inventory);
        this.#inventory.onRun = ()=>{
            this.focusOn(this.#runLine);
        };
        this.#inventory.onSelection = (shape)=>{
            this.#grid.cursorPos = {
                x: Math.floor((0, $00387b554b88a86f$export$9188d4e069e95fa0) / 2),
                y: Math.floor((0, $00387b554b88a86f$export$9188d4e069e95fa0) / 2)
            };
            this.#grid.selectShape(shape);
            this.focusOn(this.#grid);
        };
        this.#inventory.onExit = (index)=>{
            this.#grid.cursorPos = {
                x: (0, $00387b554b88a86f$export$9188d4e069e95fa0) - 1,
                y: index
            };
            this.focusOn(this.#grid);
        };
        this.#grid.onReturnShape = (shape)=>{
            this.#inventory.addShape(shape);
        };
        this.#grid.onExit = (cursorPos)=>{
            this.#inventory.cursorIndex = cursorPos.y;
            this.focusOn(this.#inventory);
        };
        this.#runLine.onExit = ()=>{
            this.focusOn(this.#inventory);
        };
    }
    focusOn(ui) {
        this.#focusedUI?.removeFocus();
        this.#focusedUI = ui;
        this.#inputManager.flush();
        ui.giveFocus();
        this.update(0);
    }
    update(delta) {
        this.#focusedUI.update(this.#inputManager, delta);
        this.#inputManager.flush();
        this.#buttons.update();
    }
    #isLandscape() {
        if (window.innerHeight < window.innerWidth) return true;
        else return false;
    }
    render(canvas, ctx) {
        if (this.#isLandscape()) canvas.height = (0, $00387b554b88a86f$export$a94a52152a1b6dd0);
        else {
            canvas.height = (0, $00387b554b88a86f$export$a94a52152a1b6dd0) * 2;
            this.#buttons.render(ctx);
        }
        ctx.fillStyle = (0, $00387b554b88a86f$export$56d196d2844d1ca1).BOARD;
        ctx.fillRect(0, 0, canvas.width, (0, $00387b554b88a86f$export$a94a52152a1b6dd0));
        this.#grid.render(ctx);
        this.#inventory.render(ctx);
        this.#runLine.render(ctx);
    }
}



const $35da740d59af89ba$var$canvas = document.querySelector("canvas");
const $35da740d59af89ba$var$ctx = $35da740d59af89ba$var$canvas.getContext("2d");
const $35da740d59af89ba$var$game = new (0, $2fdd4cd8dcfa2293$export$2e2bcd8739ae039)($35da740d59af89ba$var$canvas);
let $35da740d59af89ba$var$previousTime;
function $35da740d59af89ba$var$gameLoop(time) {
    if ($35da740d59af89ba$var$previousTime == undefined) {
        $35da740d59af89ba$var$previousTime = time;
        requestAnimationFrame($35da740d59af89ba$var$gameLoop);
        return;
    }
    const delta = (time - $35da740d59af89ba$var$previousTime) / 1000;
    $35da740d59af89ba$var$previousTime = time;
    $35da740d59af89ba$var$game.update(delta);
    $35da740d59af89ba$var$game.render($35da740d59af89ba$var$canvas, $35da740d59af89ba$var$ctx);
    requestAnimationFrame($35da740d59af89ba$var$gameLoop);
}
window.addEventListener("load", function() {
    $35da740d59af89ba$var$gameLoop(0);
    const sortedList = [
        ...(0, $09b17a1eda282565$export$2e2bcd8739ae039)
    ];
    sortedList.sort();
    document.getElementById("word-list").innerText = sortedList.join("\n");
});


//# sourceMappingURL=index.0646b41b.js.map
